import type { RasterWindow } from "../io/geoRaster";

/**
 * Converts a raster window into canvas `ImageData`.
 *
 * Unlike `viewer/textures.ts`'s `textureFromRaster`, no vertical flip is needed here: a
 * GeoTIFF's row 0 is the north edge, and canvas `ImageData` rows also run top-to-bottom, so
 * the two already agree.
 */
export function rasterToImageData(window: RasterWindow, hasAlpha: boolean): ImageData {
  const { width, height, samples } = window;
  const source = window.data as unknown as ArrayLike<number>;
  const rgba = new Uint8ClampedArray(width * height * 4);

  for (let i = 0; i < width * height; i++) {
    const from = i * samples;
    const to = i * 4;
    if (samples >= 3) {
      rgba[to] = source[from];
      rgba[to + 1] = source[from + 1];
      rgba[to + 2] = source[from + 2];
      rgba[to + 3] = samples >= 4 && hasAlpha ? source[from + 3] : 255;
    } else {
      const grey = source[from];
      rgba[to] = grey;
      rgba[to + 1] = grey;
      rgba[to + 2] = grey;
      rgba[to + 3] = samples === 2 && hasAlpha ? source[from + 1] : 255;
    }
  }
  return new ImageData(rgba, width, height);
}
